import { render } from "./Attribute.vue?vue&type=template&id=340aceb8&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"

import "./Attribute.vue?vue&type=style&index=0&id=340aceb8&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340aceb8"]])

export default __exports__